var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCopyDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1170"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 407",
    x: 4,
    y: 4,
    width: 10,
    height: 10,
    fill: "#251562"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 408",
    x: 5,
    y: 15,
    width: 10,
    height: 1,
    fill: "#251562"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 409",
    x: 15,
    y: 16,
    width: 11,
    height: 1,
    transform: "rotate(-90 15 16)",
    fill: "#251562"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCopyDark);
export default __webpack_public_path__ + "static/media/ico_copy_dark.1811232ccbe312571181950bf803e041.svg";
export { ForwardRef as ReactComponent };